import React from "react";
import { Box, Typography, Icon } from "@bca/ui-library";

interface StarRatingProps {
  rating: string;
  variant: "large" | "small";
}

const dimensions = {
  large: {
    width: "53px",
    height: "24px",
    px: "7px",
    starDimension: "13.5px",
  },
  small: {
    width: "53px",
    height: "23px",
    px: "6px",
    starDimension: "12px",
  },
};

const smallVariantCss = `
border-radius: 5px;
gap: 6px;
`;

const largeVariantCss = `
border-radius: 4px;
font-size: 13.5px;
`;

const StarRating: React.FunctionComponent<StarRatingProps> = ({
  rating,
  variant,
}) => (
  <Box
    display="flex"
    flexDirection="row"
    bg="#1D2948"
    width={dimensions[variant].width}
    height={dimensions[variant].height}
    alignItems="center"
    px={dimensions[variant].px}
    py="2px"
    css={variant === "small" ? smallVariantCss : largeVariantCss}
  >
    <>
      {variant === "small" && (
        <Typography color="white" variant="body" fontWeight="semiBold" m={0}>
          {rating}
        </Typography>
      )}
      {variant === "large" && (
        <Typography color="white" my="0" variant="h6" mr="3px">
          {rating}
        </Typography>
      )}
    </>
    <Icon
      name="star"
      weight="solid"
      color="white"
      width={dimensions[variant].starDimension}
      height={dimensions[variant].starDimension}
    />
  </Box>
);

export default StarRating;
